function Footer() {
  return (
    <footer className="bg-blue-600 text-white py-2 text-center">
      <p className="text-sm">
        © 2026 Vidya Palan
      </p>
    </footer>
  );
}

export default Footer;